<!-- 质保信息 -->
<template>
    <div v-if="componentsData.type == 25">
        <div
            class="overflow-hidden bg-div"
            :style="
                componentsData.content.version
                    ? {
                          ...(componentsData.content.bg_color && {
                              backgroundColor: componentsData.content.bg_color,
                          }),
                          ...(componentsData.content.bg_img.picview &&
                              componentsData.content.bg_value && {
                                  backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                              }),
                          padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                          margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                          borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
                      }
                    : `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;
                background: ${componentsData.content.bg_color};
                border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
            "
        >
            <div
                class="fw-bold flex-c"
                v-if="componentsData.content.style_value == 1"
                :style="`border-bottom: 1px solid ${componentsData.content.dividingline_color};
                    background: ${componentsData.content.title_bg_color}; 
                    color: ${componentsData.content.title_color}; 
                    font-size: ${componentsData.content.title_size}px;`"
            >
                <div class="dec-left" :style="{ background: decLeft }"></div>
                <div class="dec-content">
                    {{ componentsData.content.title }}
                </div>
                <div class="dec-right" :style="{ background: decRight }"></div>
            </div>
            <div
                v-else
                class="fw-bold"
                :style="`text-align: ${componentsData.content.position};
                    border-bottom: 1px solid ${componentsData.content.dividingline_color};
                    background: ${componentsData.content.title_bg_color}; 
                    color: ${componentsData.content.title_color}; 
                    font-size: ${componentsData.content.title_size}px;`"
            >
                {{ componentsData.content.title }}
            </div>
            <template v-if="componentsData.content.menu_value == 1">
                <div
                    class="text-div1"
                    :style="`color: ${componentsData.content.text_color1}; font-size: ${componentsData.content.text_size1}px;`"
                >
                    {{ componentsData.content.text1 }}
                </div>
                <div
                    class="text-btn"
                    :style="`color: ${componentsData.content.btn_text_color};
                        border: 1px solid ${componentsData.content.btn_border_color};
                        background: ${componentsData.content.btn_color};`"
                >
                    {{ componentsData.content.btn_text }}
                </div>
            </template>
            <div v-if="componentsData.content.menu_value == 2" class="m10">
                <Form label-position="top">
                    <div
                        v-for="(item, index) in componentsData.content
                            .tableList"
                        :key="index"
                    >
                        <div v-if="item.default == 1 && item.display_value == 1"
                            :style="`color: ${componentsData.content.title_color2}; font-size: ${componentsData.content.title_size2}px;`"
                        >
                            {{ item.title_name }}
                        </div>
                        <div v-if="item.default != 1"
                            :style="`color: ${componentsData.content.title_color2}; font-size: ${componentsData.content.title_size2}px;`"
                        >
                            {{ item.title_name }}
                        </div>
                        <FormItem
                            v-if="item.default == 1 && item.display_value == 1"
                            class="menu-item"
                        >
                            <Input
                                v-if="item.type == 1"
                                type="text"
                                :placeholder="item.prompt_text"
                            ></Input>
                        </FormItem>
                        <FormItem v-if="item.default != 1" class="menu-item">
                            <Input
                                v-if="item.type == 1"
                                type="text"
                                :placeholder="item.prompt_text"
                            ></Input>
                            <CheckboxGroup v-if="item.type == 2">
                                <template v-if="item.type_val">
                                    <Checkbox
                                        v-for="(e, i) in item.type_val.split(
                                            '*'
                                        )"
                                        :key="i"
                                        :label="e"
                                    ></Checkbox>
                                </template>
                            </CheckboxGroup>
                            <Input
                                v-if="item.type == 3"
                                type="textarea"
                                :placeholder="item.prompt_text"
                            ></Input>
                            <CheckboxGroup v-if="item.type == 4">
                                <template v-if="item.type_val">
                                    <Checkbox
                                        v-for="(e, i) in item.type_val.split(
                                            '*'
                                        )"
                                        :key="i"
                                        :label="e"
                                    ></Checkbox>
                                </template>
                            </CheckboxGroup>
                            <Select
                                v-if="item.type == 5"
                                :placeholder="item.prompt_text"
                            >
                                <template v-if="item.type_val">
                                    <Option
                                        v-for="(e, i) in item.type_val.split(
                                            '*'
                                        )"
                                        :value="i"
                                        :key="i"
                                        >{{ e }}</Option
                                    >
                                </template>
                            </Select>
                            <DatePicker
                                v-if="item.type == 6"
                                type="date"
                                :placeholder="item.prompt_text"
                                class="w1000"
                            ></DatePicker>
                            <div v-if="item.type == 7" class="img-divs">
                                <div class="img-div">
                                    <img
                                        src="@/assets/img.png"
                                        class="img-div-icon"
                                    />
                                </div>
                                <div class="img-txt">最多上传10张</div>
                            </div>
                            <div v-if="item.type == 8" class="img-divs">
                                <div class="img-div">
                                    <img
                                        src="@/assets/video.png"
                                        class="img-div-icon"
                                    />
                                </div>
                                <div class="img-txt">最大上传50MB视频</div>
                            </div>
                        </FormItem>
                    </div>
                    <div
                        class="menu-btn"
                        :style="`color: ${componentsData.content.btn_text_color2};background: ${componentsData.content.btn_color2};border: 1px solid ${componentsData.content.btn_border_color2};`"
                    >
                        {{ componentsData.content.btn_text2 }}
                    </div>
                </Form>
            </div>
            <div v-if="componentsData.content.menu_value == 3">
                <div class="warranty-info-txt">
                    <div
                        class="info-json-title"
                        :style="`color: ${componentsData.content.form_title_color3}; font-size: ${componentsData.content.form_txt_size3}px;`"
                    >
                        激活信息
                    </div>
                    <div
                        v-for="(e, i) in componentsData.content.tableList"
                        :key="i"
                    >
                        <div
                            class="info-json-text"
                            :style="`color: ${componentsData.content.form_text_color3}; font-size: ${componentsData.content.form_txt_size3}px;`"
                        >
                            <template v-if="e.title_name">
                                <template v-if="e.type == 1">
                                    <div
                                        v-if="
                                            e.default == 1 && e.hide_value == 2
                                        "
                                        class="json-text-title"
                                        :style="`color: ${componentsData.content.form_title_color3}; font-size: ${componentsData.content.form_txt_size3}px;`"
                                    >
                                        {{ e.title_name }}:
                                    </div>
                                    <div
                                        v-if="e.default != 1"
                                        class="json-text-title"
                                        :style="`color: ${componentsData.content.form_title_color3}; font-size: ${componentsData.content.form_txt_size3}px;`"
                                    >
                                        {{ e.title_name }}:
                                    </div>
                                </template>
                                <div
                                    v-else
                                    class="json-text-title"
                                    :style="`color: ${componentsData.content.form_title_color3}; font-size: ${componentsData.content.form_txt_size3}px;`"
                                >
                                    {{ e.title_name }}:
                                </div>
                            </template>
                            <template v-if="e.type == 1">
                                <div v-if="e.default == 1 && e.hide_value == 2">
                                    xxx
                                </div>
                                <div v-if="e.default != 1">xxx</div>
                            </template>
                            <div
                                v-if="
                                    e.type == 2 ||
                                    e.type == 3 ||
                                    e.type == 4 ||
                                    e.type == 5 ||
                                    e.type == 6
                                "
                            >
                                xxx
                            </div>
                            <div v-if="e.type == 7">
                                <div class="json-text-img"></div>
                            </div>
                            <div v-if="e.type == 8">
                                <div class="json-text-img"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt10 mb10">
                    <div v-html="componentsData.content.text3"></div>
                </div>
                <div
                    :style="`background: ${componentsData.content.bar_color};`"
                    class="progress-bar"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {
        decLeft() {
            return `linear-gradient(to left, ${this.componentsData.content.dec_color}, transparent)`;
        },
        decRight() {
            return `linear-gradient(to right, ${this.componentsData.content.dec_color}, transparent)`;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.fw-bold {
    padding-bottom: 6px;
    font-weight: bold;
}
.dec-left {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-right {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-content {
    max-width: 200px;
    white-space: nowrap; /* 确保文本不会换行 */
    overflow: hidden; /* 隐藏溢出的文本 */
    text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.text-div1 {
    margin: 24px 0;
    text-align: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
}
.text-btn {
    padding: 10px 0;
    background: #ff761d;
    border-radius: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #ffffff;
    text-align: center;
}
.progress-bar {
    width: 100%;
    height: 8px;
    border-radius: 4px;
}
.img-divs {
    padding: 10px;
    background: #f1f5f8;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.img-div {
    width: 70px;
    height: 70px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.img-div-icon {
    width: 25px;
}
.img-txt {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
}
.menu-btn {
    padding: 10px 0;
    margin-top: 12px;
    background: #ff761d;
    border-radius: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #ffffff;
    text-align: center;
}
.warranty-info-txt {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #000;
}
.info-json-title {
    margin: 10px 0;
    display: flex;
    align-items: center;
}
.info-json-title:before {
    margin-right: 6px;
    content: "";
    display: inline-block;
    width: 3px;
    height: 15px;
    background: #ff761d;
    border-radius: 5px;
}
.json-text-img {
    margin: 0 10px 6px 0;
    width: 70px;
    height: 70px;
    border-radius: 4px;
    background-color: rgb(204, 204, 204);
}
.json-text-title {
    margin-right: 6px;
    white-space: nowrap;
    color: #999;
}
.info-json-text {
    margin-bottom: 5px;
    display: flex;
}
.m10 {
    margin: 10px;
}
.w1000 {
    width: 100%;
}
.mt10 {
    margin-top: 10px;
}
.mb10 {
    margin-bottom: 10px;
}
</style>